import React, { useState, useEffect } from 'react';
import api from '../api';
import { useParams } from 'react-router-dom';
import '../scss/main.scss';
import Lottie from 'react-lottie-player';
import noInterviews from '../animations/noInterviews.json';
import Loader from './Loader';
import EvaluationsItem from './EvaluationsItem';

export default function Evaluations({user}) {
	const { id } = useParams();
	const [loading, setLoading] = useState(false);
	const [sorting, setSorting] = useState('date');
	const [evaluations, setEvaluations] = useState([]);
	const [sortedEvaluations, setSortedEvaluations] = useState([]);
	const [jobTitle, setJobTitle] = useState(null);
	const [jobDescription, setJobDescription] = useState(null);
	
	const toReadableDate = (dateString) => {
		const date = new Date(dateString);
		const readableDate = date.toLocaleString();
		return readableDate;
	}
	useEffect(() => {
		if (!id) return;
		setLoading(true);
		api.getEvaluations(id, user.token)
		.then(({ data }) => {
			if (data.status === 'SUCCESS') {
				const ev = data.data.map((evaluation) => {
					return {
						...evaluation, 
						creationDate: toReadableDate(evaluation.creationDate),
						totals: evaluation.questions.reduce((res, question) => {
							if (question.type === 'hard') {
								res[1] += question.score;
								res[2] += 1;
							} else {
								res[3] += question.score;
								res[4] += 1;
							}
							res[0] += question.score;
							return res;
						}, [0, 0, 0, 0, 0])
					}
				})
				if(ev.length > 0){
					const e = ev[0];
					setJobTitle(e.job_title)
					setJobDescription(e.job_description)
				}
				setEvaluations(ev);
			}
		})
		.catch((e) => {
			console.log(e);
		})
		.finally(() => setLoading(false))
	}, [id, user.token])
	useEffect(() => {
		const cp = [...evaluations];
		const sorted = cp?.sort((a, b) => {
			if(sorting === 'score'){
				let scoreA = a.totals[0] / a.questions.length;
				let scoreB = b.totals[0] / b.questions.length;
				return scoreB - scoreA;
			}else{
				return a?.evaluationDate?.localeCompare(b?.evaluationDate);
			}
		})
		setSortedEvaluations(sorted);
	}, [evaluations, sorting])
	return (
		<div className="page">
			{!loading && 
				<>
					{evaluations.length > 0 &&
						<>
							<div className="evaluations__title">
								Evaluations for
								{jobTitle && <h3>{jobTitle}</h3>}
								{jobDescription && <h5>{jobDescription}</h5>}
								<div className="mtop--20">
									<label className="text__bold">Sort by</label>
									<div className="flex flex__row">
										<div onClick={() => setSorting('score')} className={`btn ${sorting === 'score' ? 'btn__primary' : 'btn__secondary'}`}>Score</div>
										<div onClick={() => setSorting('date')} className={`btn ${sorting === 'date' ? 'btn__primary' : 'btn__secondary'}`}>Date</div>
									</div>
								</div>
							</div>
							<div className="evaluations">
							{sortedEvaluations.map((evaluation, idx) => {
									return (
										<EvaluationsItem data={evaluation} key={`evaluation_${idx}`}  />
									)
								})}
							</div>
						</>
					}
					{evaluations.length === 0 &&
						<div className="card card__rounded">
							<div className="text__center">
								<Lottie
									loop={true}
									animationData={noInterviews}
									play
									style={{ width: 200, height: 200, margin: 'auto' }}
								/>
								<h3>No evaluations yet.</h3>
								<div>Share this interview with others or answer it yourself</div>
							</div>
						</div>
					}	
				</>
			}
			{loading && <Loader />}
		</div>
	)
}